import React from 'react';
import styled from 'styled-components';
import { LinkButton } from '@clds/button';
import { globalTheme } from '@clds/component-theme';
import { Transform } from '@clds/icon';
import { AssetUrlProps } from '@cld/code-snippet-next';
import { buildTransformationBuilderUrlParams } from './buildTransformationBuilderUrlParams';

export type ButtonTargetMode = 'blank' | 'self';
export type ButtonTargetHost = 'tx.cloudinary.com' | 'tx.staging.cloudinary.com' | string;

export interface OpenInBuilderButtonConfig {
  enabled: boolean;
  target?: ButtonTargetMode;
  host?: ButtonTargetHost;
}

const StyledButton = styled(LinkButton)`
  margin-top: ${globalTheme.spacing.xs};
  margin-left: auto;
`;

export const OpenInTransformationBuilderButton: React.FC<
  React.PropsWithChildren<{
    parsedUrl: AssetUrlProps;
    host?: ButtonTargetHost;
    target?: ButtonTargetMode;
  }>
> = ({ parsedUrl, target = 'self', host = 'tx.cloudinary.com' }) => {
  const builderUrl = new URL(`https://${host}`);

  builderUrl.search = buildTransformationBuilderUrlParams(parsedUrl);

  return (
    <StyledButton variant="secondary" size="md" tone="plain" leftSlot={<Transform />} href={builderUrl.toString()} target={`_${target}`}>
      Open In Transformation Builder
    </StyledButton>
  );
};
